import ReactLoading from 'react-loading';
import styled from 'styled-components';

const Loader = styled(ReactLoading).attrs({
  color: 'var(--loader-color)',
  type: 'spin',
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default Loader;
